document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("load", function () {
    const elements = document.querySelectorAll(".beforeAfterElement");

    elements.forEach(function (element) {
      const isThree = element.classList.contains("three");
      const isTwo = element.classList.contains("two");

      let active = false;
      let middleMoved = false;

      const wrap = element.querySelector(".wrap");
      const scrollerMiddle = element.querySelector(".scroller-middle");
      const scrollerTop = element.querySelector(".scroller-top");
      const middle = element.querySelector(".middle");
      const top = element.querySelector(".top");

      let isMobile = window.matchMedia("(max-width: 1100px)").matches;

      window.addEventListener("resize", () => {
        isMobile = window.matchMedia("(max-width: 1100px)").matches;
      });

      /* -------------------------
         INITIAL SETUP
      ------------------------- */

      if (middle) {
        middle.style.width = "50%";
        scrollerMiddle.style.left = "50%";
        scrollerMiddle.style.zIndex = 2;
      }

      if (isThree && top) {
        top.style.width = "25%";
        scrollerTop.style.left = "25%";
        scrollerTop.style.display = "block";
        scrollerTop.style.zIndex = 1;
      }

      /* -------------------------
         CORE SCROLL LOGIC
      ------------------------- */

      function scrollIt(x) {
        const wrapWidth = wrap.offsetWidth;

        const activeScroller =
            active === "top" && scrollerTop
            ? scrollerTop
            : scrollerMiddle;

        const scrollerWidth = activeScroller.offsetWidth;

        // harte Pixel-Grenze (wie in deiner Originalversion)
        const maxPixel = wrapWidth - scrollerWidth;

        const minMobileMax = wrapWidth * 0.8;

        const allowedMax = isMobile
            ? Math.max(maxPixel, minMobileMax)
            : maxPixel;

        const clamped = Math.max(0, Math.min(x, allowedMax));

        // Prozent relativ zur kompletten Wrap-Breite
        const percent = (clamped / wrapWidth) * 100;

        /* ---------- MIDDLE ---------- */

        if (active === "middle" && middle) {
            middle.style.width = percent + "%";
            scrollerMiddle.style.left = percent + "%";

            if (isThree && !middleMoved) {
            scrollerTop.style.display = "block";
            middleMoved = true;
            }

            if (
            isThree &&
            scrollerTop.getBoundingClientRect().left >
                scrollerMiddle.getBoundingClientRect().left - 5
            ) {
            const adjusted = Math.max(0, clamped - 5);
            const adjustedPercent = (adjusted / wrapWidth) * 100;

            top.style.width = adjustedPercent + "%";
            scrollerTop.style.left = adjustedPercent + "%";
            }
        }

        /* ---------- TOP ---------- */

        if (active === "top" && top) {
            top.style.width = percent + "%";
            scrollerTop.style.left = percent + "%";

            if (
            scrollerTop.getBoundingClientRect().left >
                scrollerMiddle.getBoundingClientRect().left - 5
            ) {
            const adjusted = Math.min(allowedMax, clamped + 5);
            const adjustedPercent = (adjusted / wrapWidth) * 100;

            middle.style.width = adjustedPercent + "%";
            scrollerMiddle.style.left = adjustedPercent + "%";
            }
        }
      }

      /* -------------------------
         EVENTS
      ------------------------- */

      if (isTwo || isThree) {
        scrollerMiddle.addEventListener("mousedown", function () {
          active = "middle";
          scrollerMiddle.classList.add("scrolling");
          scrollerMiddle.style.zIndex = 3;
          if (scrollerTop) scrollerTop.style.zIndex = 2;
        });

        scrollerMiddle.addEventListener("touchstart", function () {
          active = "middle";
          scrollerMiddle.classList.add("scrolling");
          scrollerMiddle.style.zIndex = 3;
          if (scrollerTop) scrollerTop.style.zIndex = 2;
        });
      }

      if (isThree && scrollerTop) {
        scrollerTop.addEventListener("mousedown", function () {
          active = "top";
          scrollerTop.classList.add("scrolling");
          scrollerTop.style.zIndex = 3;
          scrollerMiddle.style.zIndex = 2;
        });

        scrollerTop.addEventListener("touchstart", function () {
          active = "top";
          scrollerTop.classList.add("scrolling");
          scrollerTop.style.zIndex = 3;
          scrollerMiddle.style.zIndex = 2;
        });
      }

      const stopAll = () => {
        active = false;
        scrollerMiddle.classList.remove("scrolling");
        if (isThree && scrollerTop) {
          scrollerTop.classList.remove("scrolling");
        }
      };

      ["mouseup", "mouseleave", "touchend", "touchcancel"].forEach(
        (event) => document.body.addEventListener(event, stopAll)
      );

      document.body.addEventListener("mousemove", function (e) {
        if (!active) return;
        const x = e.pageX - wrap.getBoundingClientRect().left;
        scrollIt(x);
      });

      wrap.addEventListener("touchmove", function (e) {
        if (!active) return;
        e.preventDefault();
        const x =
          e.touches[0].pageX - wrap.getBoundingClientRect().left;
        scrollIt(x);
      });
    });
  });
});
